module.exports = __webpack_public_path__ + "static/img/top_bg_app.d4a338d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/promotion/top_bg_app.png
// module id = 1100
// module chunks = 1